import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const startSubscribeBuild = createAction(types.SUBSCRIBE_BUILDS);
export const stopSubscribeBuild = createAction(types.UNSUBSCRIBE_BUILDS);
export const saveBuildsTimeout = createAction(types.SAVE_BUILDS_TIMEOUT);
export const togglePerformance = createAction(types.TOGGLE_PERFORMANCE);
